// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2S_fS","location":"Header_location__2rmP1"};